import DateRangePicker from "@wojtekmaj/react-daterange-picker"
import "./react-daterange.css"

export default DateRangePicker
